<template>
  <div>
    <a-steps :current="current" :status="status" labelPlacement="vertical">
      <a-step
        v-for="(p, index) in newProcessList"
        :key="index"
        :title="p.title">
        <template slot="description">
          <a-popover>
            <template slot="content">
              <span>{{p.assignee ? $t('system.workflow.all_assignees') + ': ' : null}}{{ p.assignees }}</span>
            </template>
            <span>{{ p.assignee ? p.assignee : p.shortAssigness }}<a-icon class="ml-2" style="color: #00000073;" v-if="p.assignee" type="question-circle" /></span>
          </a-popover>
        </template>
      </a-step>
    </a-steps>
  </div>
</template>

<script>
export default {
  name: 'ProcessList',
  props: {
    processList: {
      type: Array,
      required: true,
    },
    processInstanceInfo: {
      type: Object,
    },
  },
  data () {
    return {
      current: -1,
      allEnabledUsers: [],
    }
  },
  computed: {
    newProcessList () {
      return this.processList.map((item) => {
        let assigneesArr = Array.isArray(item.assignees) ? item.assignees : [{ id: null, name: item.assignees }]
        if (item.activity_id && this.allEnabledUsers.length) {
          assigneesArr = assigneesArr.filter(assignee => this.allEnabledUsers.some(user => user.id === assignee.id))
        }
        const assignees = (assigneesArr.map(assignee => assignee.name)).join(',')
        let assignee = ''
        if (item.activity_id) {
          const target = (this.processInstanceInfo.log || []).filter(log => log.activity_id === item.activity_id)
          if (target.length) {
            assignee = target[target.length - 1].task_assignee_name
          }
        }
        return {
          title: item.title,
          assignees: assignees,
          shortAssigness: assignees.length > 26 ? `${assignees.substring(0, 26)}...` : assignees,
          assignee,
        }
      })
    },
    // 驳回 或 系统服务调用失败
    status () {
      const { log = [] } = (this.processInstanceInfo || {})
      if (log.length) {
        const { task = {} } = log[log.length - 1]
        const { local_variables = {} } = task
        if (local_variables.hasOwnProperty('approved') && !local_variables.approved) {
          return 'error'
        }
      }
      return 'process'
    },
  },
  watch: {
    'processInstanceInfo.log': {
      handler (newVal) {
        if (newVal.length) {
          this.initCurrent()
        }
      },
      immediate: true,
    },
  },
  created () {
    this.initAllEnabledUsers()
  },
  methods: {
    initAllEnabledUsers () {
      const users = []
      this.processList.forEach(item => {
        if (Array.isArray(item.assignees)) {
          item.assignees.forEach(assignee => {
            if (assignee.id) {
              users.push(assignee.id)
            }
          })
        }
      })
      if (!users.length) return
      try {
        const manager = new this.$Manager('users', 'v1')
        const params = { scope: this.$store.getters.scope, enabled: true, filter: `id.in(${users.map(item => `'${item}'`).join(',')})` }
        manager.list({ params })
          .then((res) => {
            this.allEnabledUsers = res.data?.data || []
          })
      } catch (error) {
        console.error(error)
      }
    },
    initCurrent () {
      if (!this.processInstanceInfo) return
      const { log = [] } = (this.processInstanceInfo || {})
      if (log.length) {
        if (log[log.length - 1].activity_id === 'UserTask_User_Confirm') {
          const { task = {} } = log[log.length - 1]
          const { local_variables = {} } = task
          if (local_variables.hasOwnProperty('approved') && !local_variables.approved && this.processList[this.processList.length - 1]?.title === this.$t('common_378')) {
            this.current = this.processList.length - 1
          } else if (local_variables.hasOwnProperty('approved') && local_variables.approved && this.processList[this.processList.length - 1]?.title === this.$t('common_378')) {
            this.current = this.processList.length
          }
        } else if (log[log.length - 1].activity_type === 'serviceTask' || log[log.length - 1].activity_type === 'userTask') {
          const { task = {} } = log[log.length - 1]
          const { local_variables = {} } = task
          if (local_variables.hasOwnProperty('approved') && !local_variables.approved) {
            if (log[log.length - 1].activity_type === 'serviceTask') {
              this.current = this.processList.length - 1
            } else {
              this.current = this.processList.findIndex(item => item.activity_id === log[log.length - 1].activity_id)
            }
          } else if (local_variables.hasOwnProperty('approved') && local_variables.approved) {
            if (log[log.length - 1].activity_type === 'serviceTask') {
              this.current = this.processList.length
            } else {
              this.current = this.processList.findIndex(item => item.activity_id === log[log.length - 1].activity_id) + 1
            }
          }
        } else if (!log[log.length - 1].activity_type && log[log.length - 1].activity_name === this.$t('common_377')) {
          this.current = 1
        }
      }
    },
  },
}
</script>
